import { DataCollectionType } from 'lib_ts/enums/data-collection.enums';
import { IDataCollection } from 'lib_ts/interfaces/i-data-collection';
import { first } from 'lodash';
import { DataCollectionsService } from 'services/data-collections.service';
import { create } from 'zustand';

type HardwareDiagnosticState = {
  inProgressHwd?: IDataCollection;
  cancelConfirmKey?: number;
};

type HardwareDiagnosticActions = {
  setInProgressHwd: (hwd?: IDataCollection) => void;
  loadInProgressHwd: (machineID: string) => Promise<void>;
  tryCancel: () => void;
  dismissCancelConfirm: () => void;
};

type HardwareDiagnosticStore = HardwareDiagnosticState &
  HardwareDiagnosticActions;

export const useHardwareDiagnosticStore = create<HardwareDiagnosticStore>(
  (set, get) => ({
    inProgressHwd: undefined,
    cancelConfirmKey: undefined,

    setInProgressHwd: (hwd) => set({ inProgressHwd: hwd }),

    loadInProgressHwd: async (machineID) => {
      const existing = first(
        await DataCollectionsService.findLastInProgress({
          machineID,
          type: DataCollectionType.HardwareDiagnostic,
        })
      );

      set({ inProgressHwd: existing });
    },

    tryCancel: () => {
      if (!get().inProgressHwd) {
        return;
      }

      set({ cancelConfirmKey: Date.now() });
    },

    dismissCancelConfirm: () => set({ cancelConfirmKey: undefined }),
  })
);
